import { Tag, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import type { DiagnosticRule } from '~/app/services/diagnosticRules/diagnostic-rule.types';
import { indexingStatusTag } from '../../utils';

export function IndexingStatusTag({ rule }: { rule: DiagnosticRule }) {
  const { t } = useTranslation('diagnosticRules');
  const tag = indexingStatusTag(rule.indexingStatus);
  const node = (
    <Tag
      color={tag.color}
      icon={tag.spinning ? <LoadingOutlined /> : undefined}
    >
      {t(tag.labelKey)}
    </Tag>
  );
  return rule.indexingStatus === 'FAILED' && rule.indexingError ? (
    <Tooltip title={rule.indexingError}>{node}</Tooltip>
  ) : (
    node
  );
}
